// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:17
import { AlarmCustomerContact_abstract } from './../abstract/SagaSchema/AlarmCustomerContact_abstract';
export class AlarmCustomerContact extends AlarmCustomerContact_abstract {}
